// function buildSwatchSelector() {
//     $.getJSON('/collections/shop-all-tips/products.json?limit=100', function(response) {
//         console.log('heyo', response);

//     });
// }

window.addEventListener('DOMContentLoaded', () => {
    let data_tips_standalone_product = $('.custom-pdp-nail-select').attr('data-has-only-default-variant');
     
    if (data_tips_standalone_product === 'true') {
        let active_nails_category = $('.custom-pdp-nail-select-container').find('.pdp-nails-variant-button-label').attr('data-nails-category');
        $('.nail-swatch-grid:empty').remove();
        $('.custom-pdp-nail-swatches-set[data-requires-slider="true"]').slick({
            arrows: false,
            dots: true
        });
        // $('.custom-pdp-nail-swatches').find(`div[data-swatch="${active_nails_category}"]`).addClass('active');

        // buildSwatchSelector();
        $('.custom-pdp-nail-swatches-set').addClass('active');
    } else {
        let active_nails_category = $('.custom-pdp-nail-select-container').find('input:checked').closest('.pdp-nails-variant-button').find('.pdp-nails-variant-button-label').attr('data-nails-category');
        $('.nail-swatch-grid:empty').remove();
        $('.custom-pdp-nail-swatches-set[data-requires-slider="true"]').slick({
            arrows: false,
            dots: true
        });
        // $('.custom-pdp-nail-swatches').find(`div[data-swatch="${active_nails_category}"]`).addClass('active');

        // buildSwatchSelector();
        $('.custom-pdp-nail-swatches-set').addClass('active');
    }
});

$('.custom-pdp-nail-select').on('click', '.pdp-nails-variant-button-label', function(event) {
    $label = $(event.target).closest('.pdp-nails-variant-button-label');
    let active_nails_category = $label.attr('data-nails-category');
    
    if (active_nails_category === 'almond') {
        $('.custom-pdp-nail-select-title').html('Tip Shape: <b>Almond</b>');
    } else if (active_nails_category === 'oval') {
        $('.custom-pdp-nail-select-title').html('Tip Shape: <b>Oval</b>');
    } else if (active_nails_category === 'square') {
        $('.custom-pdp-nail-select-title').html('Tip Shape: <b>Square</b>');
    }

    // $('.custom-pdp-nail-swatches-set').removeClass('active');
    // $('.custom-pdp-nail-swatches').find(`div[data-swatch="${active_nails_category}"]`).addClass('active');
})

$('.custom-pdp-nail-swatches').on('mouseenter', '.nail-swatch-grid-item', function(event) {
    $swatch = $(event.target).closest('.nail-swatch-grid-item');
    let swatch_title = $swatch.attr('data-item-title');
    $('.pdp-nails-type-display-hover').html(`Design: <b>${swatch_title}</b>`).show();
})
$('.custom-pdp-nail-swatches').on('mouseleave', '.nail-swatch-grid-item', function(event) {
    $('.pdp-nails-type-display-hover').hide();
})

$('.sticky-atc').on('click', '.sticky-atc-submit', function(event) {
    $('#productAddToCart').trigger('click');
})